<template>
  <BQdtCard
    name="complaintsRatingsHelp"
    type="help"
  />
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'RatingsHelp',

  components: { BQdtCard },
}
</script>
